/**
 * 统计分组汇总
 *
 * 《埋点数据字典》，可复制链接后用石墨文档 App 或小程序打开
 *
 * @link https://shimo.im/docs/GPdgj8vdrWYJttyT/
 */
export const statGroupMap = /** @type {const} */ ({
  /** 运营活动 */
  ACTIVITY: 'activity-common',
})
